import { RootState } from "@/store/store";
import { ResourceType } from "@/services/cloudchipr.api";
import { selectedResourcesByMasterIdSelector } from "@/store/resources-grid/selectors/grid/selection/selectedResourcesByMasterIdSelector";

export const selectedResourcesResourceTypeByMasterIdSelector = (
  state: RootState,
  gridId: string,
): ResourceType | undefined => {
  const resources = selectedResourcesByMasterIdSelector(state, gridId);

  return resources?.at(0)?.resource_type as ResourceType;
};
